import { render, staticRenderFns } from "./AutoComplete.vue?vue&type=template&id=05bb63f4&scoped=true"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"
import style0 from "../../styles/autocomplete.scss?vue&type=style&index=0&id=05bb63f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb63f4",
  null
  
)

export default component.exports